export default (theme) => ({
  codeheader: {
    padding: "0.8rem 0.8rem",
    borderBottom: "none",
    width: "calc(100% - 1.6rem)",
    fontWeight: 600,
  },
});
